// Gating del consenso analytics: avvia/ferma i tracker in modo simmetrico e ripetibile.
// Controller puro a dipendenze iniettate, cosi' revoca e ri-consenso sono testabili senza DOM
// e senza dipendere da import.meta.env. Il flag non e' monodirezionale: stop() abilita start().

export interface AnalyticsGatingDeps {
  start: () => void;
  stop: () => void;
}

export interface AnalyticsController {
  start: () => void;
  stop: () => void;
  apply: (granted: boolean) => void;
  isRunning: () => boolean;
}

export function createAnalyticsController(deps: AnalyticsGatingDeps): AnalyticsController {
  let running = false;
  const start = () => {
    if (running) return;
    running = true;
    deps.start();
  };
  const stop = () => {
    if (!running) return;
    running = false;
    deps.stop();
  };
  return {
    start,
    stop,
    apply: (granted) => { if (granted) start(); else stop(); },
    isRunning: () => running,
  };
}
